/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable no-restricted-globals */
/* eslint-disable new-cap */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import './index.scss';
import { Dialog, Popup } from 'vant';
import { Component, Mixins } from 'vue-property-decorator';

import router from '@/router';
// import { signWithoutPasswordContract } from '@/api/native';
import { popPageManager } from '@/shared/tools/popPageManager';
import store, { updateModuleState } from '@/store';
import { LivenessProjectEnum, LivenessSceneEnum } from '@/enums/liveness-param';
import {
  getDeviceFingerprintHash,
  getSystemInfo,
  getDeviceInfo,
  nativeLocalGetData,
  nativeLocalRemoveData,
  nativeLocalSetData,
  openThirdPage,
  getCityInfo,
} from '@/api/native/utils';
import platform from '@/shared/utils/platform';
import AlipayMixins from '@/mixins/alipay';
// import { alipayOptions } from '@/views_v2/apply-product/components/select-alipay/until';
import { paySignCenterAlipay } from '@/api/native/aliMP';
// import { contractsUrl } from '@/constant';
import { SceneTypeEnum } from '@/enums/scene-type';
import { ContractItem, getContractsInfo, openContract } from '@/ContractConfig';
import { ContractData } from '@/api/contract/types';
import { ContractEnum } from '@/enums/contract-type';
import { getTokenAndKey } from '@/api/native/userInfo';
import { androidSpecialDownloadUrl, iosDownloadUrl } from '@/constant';
// import { Native } from '@hb/hbridge';
import {
  queryEvent, showAdvert, subscribeTCP, unsubscribeTCP,
} from '@/api/native/kongming';
import { getDeviceRiskData } from '@/shared/tools/startLiveness/utils';
import { asyncCaptureIdentity } from '@/shared/tools/ocr/async';
import { deleteSDKForTest } from '@/shared/tools/ocr/utils/native';
import {
  UploadTypeEnum,
  OCRModeEnum,
  OcrProcessSourceEnum,
  OcrOperationSourceEnum,
} from '@/shared/tools/ocr/enum';
import { changeTabbarShowStatus } from '@/api/native/container';
import { RouterV2Enum } from '@/router/router-names';
import hasVantOverlay from '@/shared/utils/hasVantOverlay';
import isShowContainerPath from '@/shared/utils/isShowContainerPath';
import { isNeedAlwaysAgreeProtocol } from '@hb/liveness';
import { openTextDialog } from './components/text-dialog';
import { livenessPop } from '../liveness-pop';

const HBridge = import('@hb/hbridge');

// import { contractPage } from '../contract';

const versionMatch = /version=([\d.]*)/.exec(navigator.userAgent);
const appVersion = (versionMatch && versionMatch[1]) || '';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const showAlert = (title: string, message: any): void => {
  Dialog.alert({
    title,
    className: 'DebugWindow_Dialog',
    message: typeof message === 'string' ? message : JSON.stringify(message),
  });
};

@Component({ name: 'DebugWindow' })
class DebugWindow extends Mixins(AlipayMixins) {
  private show = false;

  public get isOpen() {
    return this.show;
  }

  public open() {
    this.show = true;
    /** 隐藏tabbar */
    changeTabbarShowStatus(false);
  }

  public close() {
    this.show = false;
    setTimeout(() => {
      /** TODO: 待后续内聚逻辑到 changeTabbarShowStatus 方法内 */
      /** 没有遮罩层的时候，才显示tabbar */
      if (!hasVantOverlay()) {
        /** 在首页 我的页面 才显示tabbar */
        if (isShowContainerPath(this.$route.path)) {
          changeTabbarShowStatus(true);
        }
      }
    }, 400);
  }

  private async onFakeLogin() {
    updateModuleState('base', {
      token: await openTextDialog({
        title: 'token',
        text: store.state.base.token || '',
      }),
      /** 设置true，不去刷 新的token */
      fakeToken: true,
      forceUpdateKey: Date.now().toString(),
    });

    this.close();
  }

  private async onGetDevice() {
    try {
      if (platform.isAlipayMini) {
        showAlert('设备信息', await getSystemInfo());
        return;
      }
      showAlert('设备信息', await getDeviceInfo());
    } catch (error) {
      showAlert('设备信息获取失败 ', error);
    }
  }

  private async onGetCityInfo() {
    showAlert('地理位置', await getCityInfo());
  }

  private async onGetDeviceHash() {
    showAlert('设备指纹', await getDeviceFingerprintHash());
  }

  private async queryFingerHash() {
    showAlert('riskData', await getDeviceRiskData());
  }

  private async onLiveness() {
    this.close();

    try {
      const id = await livenessPop.getOrderId({
        project: LivenessProjectEnum.ZYQ,
        scene: LivenessSceneEnum.Authority,
        version: appVersion,
      });

      showAlert('人脸识别', id);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log('人脸识别pop error', error);
    }
  }

  // 三方链接
  private async onOpenUrl() {
    const data = await nativeLocalSetData({ key: 'finance_local', value: ['123456789'] });
    // eslint-disable-next-line no-console
    console.log('data', data);
    // openThirdPage('https://sandbox-juzi-pay.juzishuke.com/v2/webapp/main/pay-type.html?sequenceNumber=101441223074455285803');
  }

  // iframe
  private async onIframeUrl() {
    const data = await nativeLocalRemoveData({ key: 'finance_local' });
    // eslint-disable-next-line no-console
    console.log(data, '移除数据');
    // const srcUrl = 'https://ceres-contract.oss-cn-hangzhou.aliyuncs.com/stable/Ceres/preViewContract/%E9%A2%84%E8%A7%88%E5%90%88%E5%90%8C3a9b422396074311bd9bcd64111e880e.pdf?Expires=1948262742&OSSAccessKeyId=LTAI4Fj4hiaj3447mSAoo2eG&Signature=pyzqHELTebZwoDt4O0h3sP6UOS8%3D';
    // const url = `${contractsUrl}?pdf_url=${srcUrl}`;
    // contractPage.open(url);
  }

  private async onIframeUrls() {
    // 取数据
    const data = await nativeLocalGetData({ key: 'finance_local' });
    // eslint-disable-next-line no-console
    console.log(data, '平台数据');
    // location.href = 'alipays://platformapi/startapp?appId=2017050407110255&query=redirectUrl%3Dhttps%253A%252F%252Fm.hellobike.com%252FAppFinanceH5Web%252Flatest%252Falimini%252Findex.html%2523%252Falimini-home%253FopenType%253Dwebview%26h5Login%3D1';
  }

  // 签约
  private async onAlipaySign() {
    if (platform.isAlipayMini) {
      // this.alipaySign();
      const params = {
        scene: SceneTypeEnum.LOAN,
        creditApplyId: '111',
      };
      const result = await this.alipaySignParams(params);
      paySignCenterAlipay(result.params);
    }
  }

  // 支付
  private onAlipayPay() {
    openThirdPage('https://m.hellobike.com/AppFinanceContracts/pre/latest/pdf_preview/index.html?pdf_url=https://hello-finance.cn-hangzhou.oss.aliyuncs.com/pro/contract/h5/zhongyin-loan-1649648694767.pdf');
  }

  private onCheckToken() {
    this.show = false;
    // const res = await cehckUserToken({});
    // alert(JSON.stringify(res));
    window.location.href = 'https://m.hellobike.com/AppFinanceH5Web/fat/latest/index.html#/v2/apply-product?relationNo=2384028340';
  }

  private onOpenLocal() {
    // openThirdPage('https://m.hellobike.com/AppFinanceH5Web/fat/latest/index.html#/v2/apply-product');
    const data = getContractsInfo('3800', ContractEnum.APPLY).items as ContractData[];
    // eslint-disable-next-line no-console
    console.log(data[0], 'data');
    this.show = false;
    openContract(data[0] as unknown as ContractItem);
  }

  private async onGetTokenAndKey() {
    showAlert('客户端登录信息', await getTokenAndKey(false));
  }

  // 测试支付宝小程序中 跳转下载app
  private async onDownloadApp():Promise<void> {
    (await HBridge).Native.callNative({
      method: 'goOperationUrlV2',
      params: 'https://at.umtrack.com/onelink/zqOPfy?beyondMP=true',
    });
  }

  // 测试支付宝小程序中 跳转下载app
  private async onDownloadApp2():Promise<void> {
    const url = platform.isIOS ? `${iosDownloadUrl}?beyondMP=true` : `${androidSpecialDownloadUrl}?beyondMP=true`;
    (await HBridge).Native.callNative({
      method: 'goOperationUrlV2',
      params: url,
    });
  }

  private async subscribeTCPMethod() {
    // eslint-disable-next-line no-console
    console.error('孔明事件注册');
    const pageId = '臻有钱_提现申请页';
    showAlert('孔明事件注册', await subscribeTCP(pageId));
  }

  private async unsubscribeTCPMethod() {
    // eslint-disable-next-line no-console
    console.error('孔明事件取消订阅');
    const pageId = '臻有钱_提现申请页';
    showAlert('孔明事件取消订阅', await unsubscribeTCP(pageId));
  }

  private async queryEvent() {
    // eslint-disable-next-line no-console
    console.error(222);
    const pageId = '臻有钱_提现申请页';
    showAlert('孔明事件查询', await queryEvent(pageId));
  }

  private async debugKongming() {
    const pageId = '臻有钱_提现申请页';
    const data = await subscribeTCP(pageId);
    // eslint-disable-next-line no-console
    console.error('订阅成功 ', data.code, data.msg);

    setInterval(async () => {
      const { code, advertId, msg } = await queryEvent(pageId);
      // eslint-disable-next-line no-console
      console.error('事件查询 ', code, msg);
      if (code === 0 && advertId) {
        const showData = await showAdvert(pageId, advertId);
        // eslint-disable-next-line no-console
        console.error('广告位展示成功', showData.code);
        showAlert('广告位显示成功', showData);
      }
    }, 1000);
  }

  private async onDeleteOCRSDK() {
    const result = await deleteSDKForTest();
    const { code } = result || {};

    // eslint-disable-next-line no-console
    console.log('onDeleteOCRSDK code', code);
    showAlert('温馨提示', `OCR SDK 删除${code ? '成功' : '失败'}`);
  }

  private onOcrByAlbum() {
    asyncCaptureIdentity(
      UploadTypeEnum.Album,
      OCRModeEnum.BOTH,
      OcrProcessSourceEnum.OTHER,
      OcrOperationSourceEnum.GENERAL,
    ).then((res) => {
      // eslint-disable-next-line no-console
      console.log('onOcrByAlbum', res);
    });
  }

  private onOcrByCamera() {
    asyncCaptureIdentity(
      UploadTypeEnum.SDKCamera,
      OCRModeEnum.BOTH,
      OcrProcessSourceEnum.OTHER,
      OcrOperationSourceEnum.GENERAL,
    ).then((res) => {
      // eslint-disable-next-line no-console
      console.log('onOcrByCamera', res);
    });
  }

  private async onGetIsPreInstalled() {
    const isPreInstalled = await isNeedAlwaysAgreeProtocol();
    showAlert('是否预装包标识', isPreInstalled);
  }

  // 跳转到引导下载页面并使用wisdom配置
  private onGuideDownloadWithWisdom() {
    if (platform.isAlipayMini) {
      // 设置 debug 模式，强制使用 wisdom 唤端
      localStorage.setItem('financeDebugMode', 'true');
      router.push({
        path: RouterV2Enum.guideDownload,
      });
    } else {
      showAlert('提示', '请在支付宝小程序点击');
    }
  }


  private render() {
    return (
      <Popup class="DebugWindow" position="right" v-model={this.show}>
        <div v-class="content">
          <div v-class="item" onClick={this.onGetCityInfo.bind(this)}>
            获取地理位置
          </div>
          <div v-class="item" onClick={this.onGetDeviceHash.bind(this)}>
            获取设备指纹
          </div>
          <div v-class="item" onClick={this.onGetDevice.bind(this)}>
            获取设备信息
          </div>
          <div v-class="item" onClick={this.onGetIsPreInstalled.bind(this)}>
            获取是否预装包标识
          </div>
          <div v-class="item" onClick={this.onLiveness.bind(this)}>
            人脸识别
          </div>
          <div v-class="item" onClick={this.onOpenUrl.bind(this)}>
            平台存数据
          </div>
          <div v-class="item" onClick={this.onIframeUrl.bind(this)}>
            平台移除数据
          </div>
          <div v-class="item" onClick={this.onIframeUrls.bind(this)}>
            平台取数据
          </div>
          <div v-class="item" onClick={this.onAlipaySign.bind(this)}>
            支付宝签约（小程序）
          </div>
          <div v-class="item" onClick={this.onAlipayPay.bind(this)}>
            协议签章验证
          </div>
          <div v-class="item" onClick={this.onCheckToken.bind(this)}>
            回调提现页面url
          </div>
          <div v-class="item" onClick={this.onFakeLogin.bind(this)}>
            设置token
          </div>
          <div v-class="item" onClick={this.onOpenLocal.bind(this)}>
            协议获取展示
          </div>
          <div v-class="item" onClick={this.onGetTokenAndKey.bind(this)}>
            获取客户端登录信息
          </div>
          <div v-class="item" onClick={this.onDownloadApp.bind(this)}>
            支付宝小程序跳转下载app方法1
          </div>
          <div v-class="item" onClick={this.onDownloadApp2.bind(this)}>
            支付宝小程序跳转下载app方法2
          </div>
          <div v-class="item" onClick={this.debugKongming.bind(this)}>
            孔明 注册+查询+显示
          </div>
          <div v-class="item" onClick={this.subscribeTCPMethod.bind(this)}>
            注册孔明事件
          </div>
          <div v-class="item" onClick={this.unsubscribeTCPMethod.bind(this)}>
            取消订阅孔明事件
          </div>
          <div v-class="item" onClick={this.queryEvent.bind(this)}>
            查询孔明事件
          </div>
          <div v-class="item" onClick={this.queryFingerHash.bind(this)}>
            获取设备指纹对象
          </div>
          <div v-class="item" onClick={this.onDeleteOCRSDK.bind(this)}>
            删除已安装的OCR SDK（安卓6.74.0及以上）
          </div>
          <div v-class="item" onClick={this.onOcrByAlbum.bind(this)}>
            新版 OCR相册选择
          </div>
          <div v-class="item" onClick={this.onOcrByCamera.bind(this)}>
            新版 OCR拍摄选择
          </div>
          <div v-class="item" onClick={this.onGuideDownloadWithWisdom.bind(this)}>
            平台唤端测试
          </div>
        </div>
        <div v-class="close" onClick={this.close.bind(this)}>
          <p v-class="close-text">关闭</p>
        </div>
      </Popup>
    );
  }
}

let instance: DebugWindow;

export const debugWindow = {
  open(): Promise<unknown> {
    if (!instance) {
      instance = new DebugWindow({ router, store }).$mount();
      document.body.appendChild(instance.$el);
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return popPageManager.openPopPage(instance);
  },
  get isOpen(): boolean {
    return instance && instance.isOpen;
  },

  close(): void {
    instance.close();
  },
};
